<template>
  <b-container fluid>
    <h1>Purchasing History</h1>
    <b-row class="justify-content-md-center">
      <b-col class="my-2" cols=8>
          <b-form @submit="search">
            <b-form-row class="align-items-center mb-2">
              <b-col cols="2">
                <label>Part Num</label>
              </b-col>
              <b-col cols="4">
                <input type="text" v-model="partNum" class='form-control mb-2 ml-1 mr-2 mb-sm-0' onfocus="this.select();" onmouseup="return false;" />
              </b-col>
              <b-col cols="2">
                <b-button variant="primary" type="submit">Search</b-button>
              </b-col>
              <b-col cols="2">
                <label>Group By</label>
              </b-col>
              <b-col cols="2">
                <b-form-select v-model="basis" :options="['dateIssued', 'dateLastFulfillment']" />
              </b-col>
            </b-form-row>
          </b-form>
      </b-col>
    </b-row>
    <section v-if="loading" style="text-align: center;">
        <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="my-3" />
      </section>
    <b-row v-else>
      <b-col cols="2" class="d-flex align-items-center text-center">
        <b-alert show :variant="unfulfilledSum == 0 ? 'success' : 'warning'">
          <strong>Unfulfilled Purchases</strong>
          <p style="font-size: 1.33em;">{{unfulfilledSum}}</p>
        </b-alert>
      </b-col>
      <b-col cols="10">
        <b-table striped :fields="summaryColumns"  :items="summaryData" class="mt-2 fixed-table summary-table">
          <template slot='ytd' slot-scope='data'>
            {{formatNum(data.item.ytd)}}
          </template>
          <template slot='h1' slot-scope='data'>
            {{formatNum(data.item.h1)}}
          </template>
          <template slot='h2' slot-scope='data'>
            {{formatNum(data.item.h2)}}
          </template>
          <template slot='q1' slot-scope='data'>
            {{formatNum(data.item.q1)}}
          </template>
          <template slot='q2' slot-scope='data'>
            {{formatNum(data.item.q2)}}
          </template>
          <template slot='q3' slot-scope='data'>
            {{formatNum(data.item.q3)}}
          </template>
          <template slot='q4' slot-scope='data'>
            {{formatNum(data.item.q4)}}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-if="!loading">
      <b-col>
        <b-table striped :fields="poColumns" :items="poItems" class="mt-2 fixed-table">
          <template slot="dateCreated" slot-scope="data">
            <NiceDate :value="data.item.dateCreated" :showTime="false" />
          </template>
          <template slot="dateCompleted" slot-scope="data">
            <NiceDate :value="data.item.dateCompleted" :showTime="false" />
          </template>
          <template slot='qtyFulfilled' slot-scope='data'>
            {{formatNum(data.item.qtyFulfilled)}}
          </template>
          <template slot='qtyUnfulfilled' slot-scope='data'>
            {{formatNum(data.item.qtyUnfulfilled)}}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import NiceDate from '../utility/NiceDate';
import FishbowlService from '../../services/fishbowl';
import { FingerprintSpinner } from 'epic-spinners';
import moment from 'moment';

export default {
  components: {
    NiceDate,
    FingerprintSpinner,
  },
  data() {
    return {
      partNum: '',
      basis: 'dateIssued',
      exactMatch: false,
      currentInventoryOnHand: '-',
      loading: false,

      summaryColumns: [
        { key: 'year', sortable: true, class: 'right-bordered' },
        { key: 'ytd', sortable: true, label: 'YTD', class: 'right-bordered' },
        { key: 'h1', sortable: true, label: 'H1' },
        { key: 'h2', sortable: true, label: 'H2', class: 'right-bordered' },
        { key: 'q1', sortable: true, label: '1Q' },
        { key: 'q2', sortable: true, label: '2Q' },
        { key: 'q3', sortable: true, label: '3Q' },
        { key: 'q4', sortable: true, label: '4Q' },

      ],
      poColumns: [
        { key: 'num', sortable: true, label: 'PO Num' },
        { key: 'poStatus', sortable: true, label: 'PO Status' },
        { key: 'partNum', sortable: true, label: 'Part Num' },
        { key: 'dateCreated', sortable: true, label: 'Date Created' },
        { key: 'dateCompleted', sortable: true, label: 'Date Completed' },
        { key: 'qtyFulfilled', sortable: true, label: 'Qty Fulfilled' },
        { key: 'qtyUnfulfilled', sortable: true, label: 'Qty Unfulfilled' },
      ],
      summaryItems: [],
      poItems: [],
    };
  },
  methods: {
    search(event) {
      event.preventDefault();
      this.loading = true
      FishbowlService.getPurchaseHistory(this.partNum).then(data => {
        this.poItems = data
        this.loading = false
      });
    },
    itemsByYear(y) {
      return this.poItems.filter( i => moment(i[this.basis]).year() === y)
    },
    itemsByQtr(y,q) {
      return this.itemsByYear(y).filter( i => moment(i[this.basis]).month() >= ((q-1)*3) && moment(i[this.basis]).month() < (q*3) )
    },
    mapFulfilledQty(set) {
      return set.map( i => +i.qtyFulfilled).reduce( (a,v) => a+v, 0)
    },
    formatNum(num) {
      return (+Math.round(num, 2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  computed: {
    csvPath() {
      return ''
    },
    uniqueYears() {
      return this.poItems.map( e => moment(e[this.basis]).year() ).filter( (e,i,s) => s.indexOf(e) === i )
    },
    unfulfilledSum() {
      return this.poItems.filter( i => +i.qtyUnfulfilled > 0 && i.poStatus != 'Void').map( i => +i.qtyUnfulfilled).reduce( (a,v) => a+v, 0)
    },
    summaryData() {
      return this.uniqueYears.map( y => {
        return {
          year: y,
          ytd: this.mapFulfilledQty(this.itemsByYear(y)),
          q1: this.mapFulfilledQty(this.itemsByQtr(y, 1)),
          q2: this.mapFulfilledQty(this.itemsByQtr(y, 2)),
          q3: this.mapFulfilledQty(this.itemsByQtr(y, 3)),
          q4: this.mapFulfilledQty(this.itemsByQtr(y, 4)),
          h1: this.mapFulfilledQty(this.itemsByQtr(y, 1)) + this.mapFulfilledQty(this.itemsByQtr(y, 2)),
          h2: this.mapFulfilledQty(this.itemsByQtr(y, 3)) + this.mapFulfilledQty(this.itemsByQtr(y, 4)),
        }
      })
    }
  }
}
</script>

<style>
  .right-bordered {
    border-right: 2px solid #293a93;
  }

  .right-bordered + th, .right-bordered + td {
    padding-left: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/purchasing/PurchasingHistory.vue